import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureRemixErrorBoundaryError } from '@sentry/remix';

import { type MatchesCouponIndexProps, MatchesCouponWithQuery } from '@cx-modules/matches-coupon';

export const MatchesCoupon = (props: Omit<MatchesCouponIndexProps, 'i18n'>) => {
  const { i18n } = useTranslation();

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureRemixErrorBoundaryError(error);
        return null;
      }}
    >
      <MatchesCouponWithQuery {...props} i18n={i18n} />
    </ErrorBoundary>
  );
};
